import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp, unwrapEdges } from 'src/lib/graphql';
import type {
  BackendFacebookUserAdAccount,
  BackendFacebookUserData,
  BackendFacebookUserPage,
  BackendMutationAuthorizeFacebookArgs,
} from 'src/types/backend';

import { FACEBOOK_USER_AD_ACCOUNT_FRAGMENT, FACEBOOK_USER_PAGE_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation AuthorizeFacebook($customerId: ID!, $token: String!) {
    authorizeFacebook(customerId: $customerId, token: $token) {
      authState

      adAccounts {
        edges {
          node {
            ...FacebookUserAdAccount
          }
        }
      }

      pages {
        edges {
          node {
            ...FacebookUserPage
          }
        }
      }
    }
  }
  ${FACEBOOK_USER_AD_ACCOUNT_FRAGMENT}
  ${FACEBOOK_USER_PAGE_FRAGMENT}
`;

type Variables = BackendMutationAuthorizeFacebookArgs;
type Result = BackendFacebookUserData;

export const authorizeFacebook = async (variables: Variables) => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });
  const result = getSingleProp<Result>(response.data);

  const adAccounts = unwrapEdges<BackendFacebookUserAdAccount>(
    result?.adAccounts?.edges as Array<{ node: BackendFacebookUserAdAccount }> | undefined
  );
  const pages = unwrapEdges<BackendFacebookUserPage>(
    result?.pages?.edges as Array<{ node: BackendFacebookUserPage }> | undefined
  );

  return { adAccounts, authState: result?.authState, pages };
};
